import { i18n } from '@js/i18n'
import { documentTypes } from '@const'

export default {
  form: {
    idDocumentType: '',
    idDocumentNumber: '',
    docs: {
      [documentTypes.kycIdDocument]: null
    }
  },
  requiredDocs: [documentTypes.kycIdDocument],
  rows: [
    [
      {
        "heading": i18n.kyc_upload_one_of_docs()
      }
    ],
    [
      {
        "list": [i18n.kyc_valid_passport(),
                i18n.kyc_driving_license(),
                i18n.kyc_national_id()]
      }
    ],
    [
      {
        "subheading": i18n.kyc_id_docs_tip()
      },
      {
        "subheading": i18n.kyc_submit_personal_information()
      }
    ],
    [
      {
        "model": "idDocumentType",
        "name": "id-document-type",
        "id":  "kyc-id-document-type",
        "label": i18n.lbl_document_type(),
        "field": "vue-select",
        "required": true,
        "values": "documentTypes",
        "validate": "required"
      }
    ],
    [
      {
        "model": "idDocumentNumber",
        "name": "id-document-number",
        "id":  "kyc-id-document-number",
        "label": i18n.lbl_kyc_id(),
        "field": "text",
        "type": "tel",
        "required": true,
        "validate": "required"
      }
    ],
    [
      {
        "name": "kyc-file-id",
        "id":  "kyc-file-id",
        "label": i18n.kyc_upload_document_photo(),
        "field": "file",
        "side": "front",
        "fileType": "image",
        "required": true,
        "type": documentTypes.kycIdDocument,
        "validate": "required"
      }
    ],
    [
      {
        "model": "privacyPolicy",
        "field": "agreementCheckbox",
        "id": "privacy-policy",
        "type": "check",
        "required": true
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/general/step-2.id-document.schema.js